<app-dialog-container
  [title]="'General.Welcome'"
  [subtitle]="'Module.Reception.LandingPage.Introduction'"
  [size]="'large'"
  (closeDialogClicked)="receptionService.closeDialog()"
>
  <div class="grid grid-cols-1 lg:grid-cols-[1fr,300px] gap-6 min-h-full">
    <div class="space-y-6">
      <!-- Promo Code Section -->
      <div class="bg-gray-50 rounded-xl border border-gray-200 overflow-hidden">
        <div class="px-4 py-3 border-b border-gray-200 bg-gray-100">
          <h4 class="!m-0 !py-0 text-base font-medium text-gray-600">
            {{ "Button.Reception.RedeemCode" | transloco }}
          </h4>
        </div>
        <div class="p-4">
          <div class="flex flex-col gap-4">
            <div class="flex gap-4">
              <mat-form-field class="w-1/2">
                <mat-label>{{ "Module.Reception.PromotionCode.EnterCode" | transloco }}</mat-label>
                <input matInput #promoCodeInput placeholder="{{ 'Module.Reception.PromotionCode.EnterCode' | transloco }}" />
              </mat-form-field>
              <button mat-raised-button color="primary" class="flex-1" (click)="receptionService.redeemCode(promoCodeInput.value)">
                {{ "Button.Reception.RedeemCode" | transloco }}
              </button>
            </div>
            @if (receptionService.errorMessage()) {
              <div class="text-red-600 text-sm">
                {{ receptionService.errorMessage() | transloco }}
              </div>
            }
          </div>
        </div>
      </div>

      <!-- How to Use Section -->
      <div class="bg-white rounded-xl border border-gray-200">
        <div class="px-4 py-3 border-b border-gray-200 bg-gray-100">
          <h4 class="!m-0 !py-0 text-base font-medium text-gray-600">
            {{ "Module.Reception.LandingPage.HowToUse" | transloco }}
          </h4>
        </div>
        <div class="p-6">
          <div class="grid">
            <div class="space-y-4">
              <h5>{{ "Module.Reception.LandingPage.MostUsageTitle" | transloco }}</h5>

              <div class="text-gray-600 font-bold">{{ "Module.Reception.LandingPage.UseCases.Agents.Title" | transloco }}</div>
              <ul class="list-disc list-outside ml-6 space-y-3 text-gray-600">
                <li>{{ "Module.Reception.LandingPage.UseCases.Agents.Bullet1" | transloco }}</li>
                <li>{{ "Module.Reception.LandingPage.UseCases.Agents.Bullet2" | transloco }}</li>
                <li>{{ "Module.Reception.LandingPage.UseCases.Agents.Bullet3" | transloco }}</li>
                <li>{{ "Module.Reception.LandingPage.UseCases.Agents.Bullet4" | transloco }}</li>
                <li>{{ "Module.Reception.LandingPage.UseCases.Agents.Bullet5" | transloco }}</li>
              </ul>

              <div class="text-gray-600 font-bold">{{ "Module.Reception.LandingPage.UseCases.Appraisers.Title" | transloco }}</div>
              <ul class="list-disc list-outside ml-6 space-y-3 text-gray-600">
                <li>{{ "Module.Reception.LandingPage.UseCases.Appraisers.Bullet1" | transloco }}</li>
                <li>{{ "Module.Reception.LandingPage.UseCases.Appraisers.Bullet2" | transloco }}</li>
                <li>{{ "Module.Reception.LandingPage.UseCases.Appraisers.Bullet3" | transloco }}</li>
                <li>{{ "Module.Reception.LandingPage.UseCases.Appraisers.Bullet4" | transloco }}</li>
                <li>{{ "Module.Reception.LandingPage.UseCases.Appraisers.Bullet5" | transloco }}</li>
              </ul>

              <div class="text-gray-600 font-bold">{{ "Module.Reception.LandingPage.UseCases.Banks.Title" | transloco }}</div>
              <ul class="list-disc list-outside ml-6 space-y-3 text-gray-600">
                <li>{{ "Module.Reception.LandingPage.UseCases.Banks.Bullet1" | transloco }}</li>
                <li>{{ "Module.Reception.LandingPage.UseCases.Banks.Bullet2" | transloco }}</li>
                <li>{{ "Module.Reception.LandingPage.UseCases.Banks.Bullet3" | transloco }}</li>
                <li>{{ "Module.Reception.LandingPage.UseCases.Banks.Bullet4" | transloco }}</li>
              </ul>

              <div class="text-gray-600 font-bold">{{ "Module.Reception.LandingPage.UseCases.Investors.Title" | transloco }}</div>
              <ul class="list-disc list-outside ml-6 space-y-3 text-gray-600">
                <li>{{ "Module.Reception.LandingPage.UseCases.Investors.Bullet1" | transloco }}</li>
                <li>{{ "Module.Reception.LandingPage.UseCases.Investors.Bullet2" | transloco }}</li>
                <li>{{ "Module.Reception.LandingPage.UseCases.Investors.Bullet3" | transloco }}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Sidebar -->
    <div class="bg-purple-50 rounded-xl border border-purple-100 p-6">
      <h3 class="text-lg font-medium text-gray-900 mb-6">
        {{ "Module.Reception.LandingPage.Content.Header" | transloco }}
      </h3>
      <div class="space-y-6">
        <ul class="list-disc list-outside ml-6 space-y-3 text-gray-600">
          <li>{{ "Module.Reception.LandingPage.Content.Residential" | transloco }}</li>
          <li>{{ "Module.Reception.LandingPage.Content.Commercial" | transloco }}</li>
          <li>{{ "Module.Reception.LandingPage.Content.Comparables" | transloco }}</li>
          <li>{{ "Module.Reception.LandingPage.Content.Layer" | transloco }}</li>
          <li>{{ "Module.Reception.LandingPage.Content.FurtherInfo" | transloco }}</li>
          <li>{{ "Module.Reception.LandingPage.Content.Monitoring" | transloco }}</li>
          <li>{{ "Module.Reception.LandingPage.Content.Lead" | transloco }}</li>
          <li>{{ "Module.Reception.LandingPage.Content.App" | transloco }}</li>
        </ul>
        <div class="pt-4 border-t border-purple-100">
          <div class="text-base font-medium text-gray-900 mb-2">{{ "Button.MoreInformation" | transloco }} </div>
          <app-text-button [text]="'Module.Reception.LandingPage.VideoExample'" (buttonPressed)="goToVideoExamples()" />
        </div>
      </div>
    </div>
  </div>

  <div footer>
    <div class="flex justify-end p-4">
      <button mat-raised-button color="primary" (click)="goToContactForm()">
        {{ "Title.SubTitle.Contact" | transloco }}
      </button>
    </div>
  </div>
</app-dialog-container>
